module.exports = __webpack_public_path__ + "img/space.5dfcaeb9.jpeg";